import React from 'react';
import { leadershipStats } from '../data/mock';
import * as LucideIcons from 'lucide-react';
import { Award, Trophy, Star, Medal } from 'lucide-react';

const StatCard = ({ stat }) => {
  const IconComponent = LucideIcons[stat.icon] || LucideIcons.Activity;
  
  return (
    <div className="stat-card">
      <div className="stat-icon">
        <IconComponent size={32} />
      </div>
      <div className="stat-content">
        <span className="stat-value">{stat.value}</span>
        <span className="stat-label">{stat.label}</span>
      </div>
    </div>
  );
};

const LeadershipImpact = () => {
  const awards = [
    { icon: Trophy, title: "International Bridge Conference Leadership Ribbon", year: "2015" },
    { icon: Medal, title: "ASCE Outstanding Civil Engineer", year: "2018" },
    { icon: Star, title: "ENR Top 25 Newsmaker", year: "2020" },
    { icon: Award, title: "Czech-American Chamber Excellence Award", year: "2022" }
  ];

  return (
    <section className="leadership-section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Impact</span>
          <h2 className="heading-2">Leadership & Achievements</h2>
        </div>
        
        <div className="stats-grid">
          {leadershipStats.map((stat, index) => (
            <StatCard key={index} stat={stat} />
          ))}
        </div>
        
        <div className="awards-container">
          <h3 className="heading-4">Recognition & Awards</h3>
          <div className="awards-grid">
            {awards.map((award, index) => {
              const Icon = award.icon;
              return (
                <div key={index} className="award-card">
                  <div className="award-icon">
                    <Icon size={28} />
                  </div>
                  <div className="award-info">
                    <span className="award-title">{award.title}</span>
                    <span className="award-year">{award.year}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipImpact;
